import request from '@/utils/server'
// 新增
  export function addRole(data) {
    return request({
      url: '/role/addRole',
      
      method: 'POST',
      data:data
    })
  }
//  请求列表
export function getRoleList(query) {
  return request({
    url: '/role/getRoleList',
    method: 'get',
    params: query
  })
}
// 删除
export function delRole(data) {
    return request({
      url: '/role/delRole',
    method: 'POST',
      data:data
    })
  }
//   修改
export function editRole(data) {
    return request({
      url: '/role/editRole',
      method: 'POST',
      data:data
    })
  }
// 请求侧边栏
export function getRoleMenuByRole(query) {
  return request({
    url: '/menu/getRoleMenuByRole',
    method: 'get',
    params: query
  })
}
//   修改侧边框
export function editPermission(data) {
    return request({
      url: '/menu/editPermission',
      method: 'POST',
      data:data
    })
  }